export const SERVICE_IDS = [
  "global",
  "nurie",
  "chariiin",
  "kentei-pro",
  "kentei-pro.aws",
  "kentei-pro.nursing",
  "kentei-gokko",
  "kentei-gokko.us",
] as const;

export const LANGS = ["ja", "en", "zh", "es"] as const;

export const INBOUND_TYPES = ["feedback", "inquiry"] as const;

export const INBOUND_STATUSES = ["open", "resolved"] as const;
